import {DomainEvent} from './DomainEvent';
import {Gallery} from '../resources/Gallery';

export class MatchGalleryUploaded extends DomainEvent<Gallery> {}
